import "./styles.scss";

interface Props {
  fadeOut: boolean;
}

const SplashScreen = ({ fadeOut }: Props) => {
  return (
    <svg
      className={`splash-screen ${fadeOut ? "fade-out" : ""}`}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1080 1920"
    >
      <rect className="bg" x="0" y="0" width="1080" height="1920" />

      <g transform="translate(540,760)">
        <circle className="ring draw inner" r="420" />
        <circle className="ring draw outer" r="540" />
      </g>

      <g className="fade-in text-group" textAnchor="middle">
        <text className="title fg" x="540" y="780" fontSize="116">
          COLLAB
        </text>
        <text className="subtitle muted" x="540" y="820" fontSize="26">
          Work & Build Together
        </text>
      </g>

      <g className="fade-in brand-group" textAnchor="middle">
        <text className="brand fg" x="540" y="1760" fontSize="26">
          SORDO MADALENO
        </text>
      </g>
    </svg>
  );
};

export default SplashScreen;
